import { MessagesTitles, MessagesStatus } from './../../../models/messages';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { RiesgoService } from 'app/services/riesgo/riesgo.service';
import { Chart } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Swal from 'sweetalert2';

/* Register the plugin to all charts */
Chart.plugins.register(ChartDataLabels);

import { exportJsonToExcel } from 'app/shared/servifin-excel.export';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-dashboard-concentracion-fondo',
  templateUrl: './dashboard-concentracion-fondo.component.html',
  styleUrls: ['./dashboard-concentracion-fondo.component.scss'],
  providers: [MessagesTitles, MessagesStatus]
})
export class DashboardConcentracionFondoComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  displayedColumnsSoles = ['Nombre_Fondo', 'Monto_Fondo_Disponible', 'Monto_Fondo_Ejecutado'];
  displayedColumnsDolares = ['Nombre_Fondo', 'Monto_Fondo_Disponible', 'Monto_Fondo_Ejecutado'];
  displayedColumnsAdquirenteSoles = ['Num_Doc_Identificacion', 'Razon_Social', 'montoFondo'];
  displayedColumnsAdquirenteDolares = ['Num_Doc_Identificacion', 'Razon_Social', 'montoFondo'];
  displayedColumnsDetalleFondo = ['Nombre_Sector', 'Monto_Sector_Fondo', 'Monto_Sector_Fondo_Bloqueado', 'Monto_Sector_Fondo_Disponible', 'Monto_Sector_Fondo_Ejecutado'];
  displayedColumnsDetalleAdquirente = ['idComprobante', 'Nombre_Fondo', 'VNPP', 'Porcentaje_Fondo', 'Moneda_Descripcion', 'Fecha_Vencimiento'];

  dataSourceSoles: any;
  dataSourceDolares: any;
  dataSourceDetalleFondo: any;
  dataSourceAdquirenteSoles: any;
  dataSourceAdquirenteDolares: any;
  dataSourceAdquirenteDetalle: any;

  @ViewChild('paginatorFondoSoles', { static: false }) paginatorFondoSoles: MatPaginator;
  @ViewChild('paginatorFondoDolares', { static: false }) paginatorFondoDolares: MatPaginator;
  @ViewChild('paginatorAdquirenteSoles', { static: false }) paginatorAdquirenteSoles: MatPaginator;
  @ViewChild('paginatorAdquirenteDolares', { static: false }) paginatorAdquirenteDolares: MatPaginator;
  @ViewChild('paginatorDetalleFondo', { static: false }) paginatorDetalleFondo: MatPaginator;
  @ViewChild('paginatorDetalleAdquirente', { static: false }) paginatorDetalleAdquirente: MatPaginator;

  private sortFondoSoles: MatSort;
  private sortFondoDolares: MatSort;
  private sortAdquirenteSoles: MatSort;
  private sortAdquirenteDolares: MatSort;
  private sortDetalleFondo: MatSort;
  private sortDetalleAdquirente: MatSort;

  loading: boolean;
  isLoading: boolean;
  sector: boolean = false;
  cartera: any[] = [];
  fondo: any = [];
  fondoNombreSoles: any = [];
  fondoNombreDolares: any = [];
  colors: any = [];
  fondoMontoSoles: any = [];
  fondoMontoDolares: any = [];
  montoFondoDisponible: any = [];
  fondoSoles: any = [];
  fondoDolares: any = [];
  sectores: any = [];
  popup: boolean = false;
  popupAdquirente: boolean = false;
  listaSectores: any = [];
  porcentaje: any = [];

  montoTotalS = 0;
  montoDisponibleS = 0;
  montoEjecutadoS = 0;
  montoTotalD = 0;
  montoDisponibleD = 0;
  montoEjecutadoD = 0;

  fondonombre: any;
  moneda: any;
  pieChartSectorDolares: any = [];
  pieChartSectorSoles: any = [];
  pieChartFondoSoles: any = [];
  pieChartFondoDolares: any = [];

  nombreSectorSoles: any = [];
  montoSectorFondoSoles: any = [];
  porcentajeSectorSoles: any = [];

  nombreSectorDolares: any = [];
  montoSectorFondoDolares: any = [];
  porcentajeSectorDolares: any = [];

  datareporte: any = [];

  listadoCAdquirentes: any = [];
  listadoCAdquirentesSoles: any = [];
  listadoCAdquirentesDolares: any = [];
  detalleAdquirente: any = [];
  nombreAdquirente: any = [];

  monedaSelect: any = this.Label_id_soles;
  selected = 0;
  selectMonedaFondo: any;


  constructor(private riesgoService: RiesgoService) {
    this.fondoNombreSoles = ["ACRES Fondo", "CRECER", "Nuevo Fondo 1", "FONDO XII edit", "fondo x", "nombre fondo XIII", "CONSORCIO PROGRESO soles MUL", "ACRES Fondo"];
    this.fondoMontoSoles = [150000, 350000, 40000, 145000, 100230, 120000, 300000, 180000];
    this.nombreSectorSoles = ["TRANSPORTE", "SALUD", "COMERCIALIZADORAS", "INMOBILIARIAS"];
    this.montoSectorFondoSoles = [13232, 35400, 11815, 10000];
    this.porcentajeSectorSoles = [69.87, 18.65, 6.22, 5.27];

  }

  ngOnInit() {
    this.crearChartFondoSoles();
    this.crearChartSectorSoles();
    this.ListarFondoGeneral();
    this.ListarSectores();
    this.listadoConcentracionAdquirentes()
    this.obtenerReportecartera();
  }
  ExportTOExcel() {
    exportJsonToExcel(this.datareporte, 'Sheet1', 'Reporte_Cartera_');
  }

  ListarFondoGeneral() {
    this.loading = true;
    this.riesgoService.obtenerFondos().subscribe(
      res => {
        this.loading = false;
        this.fondo = res;
        this.fondo = this.fondo.filter(estado => estado.Estado == "A");
        this.selectMonedaFondo = this.fondo.filter(mon => mon.Moneda == this.monedaSelect);
        this.fondoSoles = this.fondo.filter(moneda => moneda.Moneda == this.Label_id_soles);
        this.fondoNombreSoles = [];
        this.fondoMontoSoles = [];
        for (let item of this.fondoSoles) {
          this.fondoNombreSoles.push(item.Nombre_Fondo)
          this.fondoMontoSoles.push(Number(item.Monto_Fondo))
        }

        this.pieChartFondoSoles.data.datasets[0].data = this.fondoMontoSoles
        this.pieChartFondoSoles.data.labels = this.fondoNombreSoles;
        this.pieChartFondoSoles.update();


        this.fondoDolares = this.fondo.filter(moneda => moneda.Moneda == this.Label_id_dolares);
        for (let item of this.fondoDolares) {
          this.fondoNombreDolares.push(item.Nombre_Fondo)
          this.fondoMontoDolares.push(Number(item.Monto_Fondo))
        }
        this.crearChartFondoDolares();

        this.dataSourceSoles = new MatTableDataSource(this.fondoSoles)
        this.dataSourceSoles.paginator = this.paginatorFondoSoles;
        this.dataSourceSoles.sort = this.sortFondoSoles;

        this.dataSourceDolares = new MatTableDataSource(this.fondoDolares);
        this.dataSourceDolares.sort = this.sortFondoDolares;
        this.dataSourceDolares.paginator = this.paginatorFondoDolares;

        this.loading = false;
        this.calcularTotalFondo();
      }, err => {
        Swal.fire({
          title: "¡Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
        this.isLoading = false;
        this.loading = false
      }
    )
  }

  changeClient(idFondo) {

    for (let item of this.listaSectores) {
      if (item.idFondo == idFondo) {
        if (this.monedaSelect == this.Label_id_soles) {
          this.nombreSectorSoles = [];
          this.montoSectorFondoSoles = [];
          this.porcentajeSectorSoles = [];
          for (let valor of item.fondos_soles) {
            this.nombreSectorSoles.push(valor.Nombre_Sector);
            this.montoSectorFondoSoles.push(Number(valor.Monto_Financiamiento_Sector_Fondo));
            this.porcentajeSectorSoles.push(Number(valor.Porcentaje_Financiamiento_Sector_Fondo));
          }
        } else if (this.monedaSelect = this.Label_id_dolares) {
          this.nombreSectorDolares = [];
          this.montoSectorFondoDolares = [];
          this.porcentajeSectorDolares = [];
          for (let valor of item.fondos_dolares) {
            this.nombreSectorDolares.push(valor.Nombre_Sector);
            this.montoSectorFondoDolares.push(Number(valor.Monto_Financiamiento_Sector_Fondo));
            this.porcentajeSectorDolares.push(Number(valor.Porcentaje_Financiamiento_Sector_Fondo));
          }
        }
      }
    }

    this.setDataPieCharts(this.monedaSelect);
  }

  setDataPieCharts(monedaSelect: number) {
    if (monedaSelect == this.Label_id_soles) {
      this.pieChartSectorSoles.data.datasets[0].data = this.montoSectorFondoSoles;
      this.pieChartSectorSoles.data.labels = this.nombreSectorSoles;
      this.pieChartSectorSoles.update();
    } else if (monedaSelect = this.Label_id_dolares) {
      this.pieChartSectorDolares.data.datasets[0].data = this.montoSectorFondoDolares;
      this.pieChartSectorDolares.data.labels = this.nombreSectorDolares;
      this.pieChartSectorDolares.update();
    }
  }

  monedaSeleccionada(moneda: number) {
    this.monedaSelect = moneda
    this.selected = 0;
    this.selectMonedaFondo = this.fondo.filter(mon => mon.Moneda == this.monedaSelect);
    this.changeClient(this.selected);
  }

  ListarSectores() {
    this.loading = true;
    this.riesgoService.listarFinanciamientoSector().subscribe(
      res => {
        this.listaSectores = res;
        this.nombreSectorSoles = [];
        this.montoSectorFondoSoles = [];
        this.porcentajeSectorSoles = [];
        for (let item of this.listaSectores) {
          if (item.idFondo == 0) {
            for (let valor of item.fondos_soles) {
              this.nombreSectorSoles.push(valor.Nombre_Sector)
              this.montoSectorFondoSoles.push(Number(valor.Monto_Financiamiento_Sector_Fondo))
              this.porcentajeSectorSoles.push(Number(valor.Porcentaje_Financiamiento_Sector_Fondo))
            }
            for (let valor of item.fondos_dolares) {
              this.nombreSectorDolares.push(valor.Nombre_Sector)
              this.montoSectorFondoDolares.push(Number(valor.Monto_Financiamiento_Sector_Fondo))
              this.porcentajeSectorDolares.push(Number(valor.Porcentaje_Financiamiento_Sector_Fondo))
            }
          }

        }
        this.pieChartSectorSoles.data.datasets[0].data = this.montoSectorFondoSoles
        this.pieChartSectorSoles.data.labels = this.nombreSectorSoles;
        this.pieChartSectorSoles.update();

        this.crearChartSectorDolares();
        this.loading = false;
      },
      () => {
        this.loading = false;
        Swal.fire({
          title: 'Error',
          text: "Sector no encontrado. Contactar con soporte.",
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );
  }

  listadoConcentracionAdquirentes() {
    this.riesgoService.listarConcentracionAdquirente().subscribe(
      resp => {
        this.listadoCAdquirentes = resp;
        this.listadoCAdquirentesSoles = this.listadoCAdquirentes.adquirientes_soles
        this.listadoCAdquirentesDolares = this.listadoCAdquirentes.adquirientes_dolares
        this.dataSourceAdquirenteSoles = new MatTableDataSource(this.listadoCAdquirentesSoles);
        this.dataSourceAdquirenteSoles.sort = this.sortAdquirenteSoles;
        this.dataSourceAdquirenteSoles.paginator = this.paginatorAdquirenteSoles;
        this.dataSourceAdquirenteDolares = new MatTableDataSource(this.listadoCAdquirentesDolares);
        this.dataSourceAdquirenteDolares.sort = this.sortAdquirenteDolares;
        this.dataSourceAdquirenteDolares.paginator = this.paginatorAdquirenteDolares;
      },
      () => {
        Swal.fire({
          title: 'Error',
          text: "Concentración de "+this.Label_Adquirentes.toLowerCase()+" no encontrado. Contactar con soporte.",
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );
  }

  obtenerReportecartera() {
    this.riesgoService.obtenerReporte().subscribe(
      res => {
        this.datareporte = res;
      }
    )
  }

  crearChartFondoSoles() {
    var self = this;
    this.pieChartFondoSoles = new Chart('pieChartFondoSoles', {
      type: 'pie',
      data: {
        labels: this.fondoNombreSoles,
        datasets: [{
          label: '#',
          data: this.fondoMontoSoles,
          backgroundColor: ["#0074D9", "#001f3f", "#2ECC40", "#FF851B", "#7FDBFF", "#B10DC9", "#FFDC00", "#FF4136", "#39CCCC",
            "#01FF70", "#85144b", "#F012BE", "#3D9970", "#111111", "#AAAAAA", "#f38b4a", "#56d798", "#ff8397", "#6970d5", "#FF86BA",
            "#A3940D", "#058AA3", "#944E6D", "#BD6500"],
          hoverBackgroundColor: this.colors,
          borderWidth: 1
        },
        ]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            color: 'white',
            anchor: "center",
            align: "end",
            font: {
              weight: 'bold'
            },
            formatter: (value, ctx) => {
              var sum = self.fondoMontoSoles.reduce(function (a, b) { return a + b; });
              return (value * 100 / sum).toFixed(2) + "%";
            },
          }
        },
          tooltips: {
          enabled: true,
          callbacks : {
            label: function(tooltipItem, data) {
                return '  S/ '+data['datasets'][0]['data'][tooltipItem['index']].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        }
      },
        legend:{
          position : 'right',
          textDirection: 'ltr',
            labels: {
              usePointStyle: true,
              fontColor: "#006192",
            }
        }
      },

    });
    this.pieChartFondoSoles.update();
  }

  crearChartFondoDolares() {
    var self = this;
    this.pieChartFondoDolares = new Chart('pieChartFondoDolares', {
      type: 'pie',
      data: {
        labels: this.fondoNombreDolares,
        datasets: [{
          label: '#',
          data: this.fondoMontoDolares,
          backgroundColor: ["#0074D9", "#001f3f", "#2ECC40", "#FF851B", "#7FDBFF", "#B10DC9", "#FFDC00", "#FF4136", "#39CCCC",
            "#01FF70", "#85144b", "#F012BE", "#3D9970", "#111111", "#AAAAAA", "#f38b4a", "#56d798", "#ff8397", "#6970d5", "#FF86BA",
            "#A3940D", "#058AA3", "#944E6D", "#BD6500"],
          hoverBackgroundColor: this.colors,
          borderWidth: 1
        },
        ]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            color: 'white',
            anchor: "center",
            align: "end",
            font: {
              weight: 'bold'
            },
            formatter: (value, ctx) => {
              var sum = self.fondoMontoDolares.reduce(function (a, b) { return a + b; });
              return (value * 100 / sum).toFixed(2) + "%";
            },
          }
        },
        tooltips: {
          enabled: true,
          callbacks : {
            label: function(tooltipItem, data) {
                return '  $ '+data['datasets'][0]['data'][tooltipItem['index']].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        }
      },
        legend:{
          position : 'right',
          textDirection: 'ltr',
            labels: {
              usePointStyle: true,
              fontColor: "#006192",
            }
        }
      },

    });

    this.pieChartFondoDolares.update();
  }

  crearChartSectorSoles() {
    var self = this;
    this.pieChartSectorSoles = new Chart('pieChartSectorSoles', {
      type: 'bar',
      data: {
        labels: this.nombreSectorSoles,
        datasets: [{
          label: 'Total',
          data: this.montoSectorFondoSoles,
          backgroundColor: ["#0074D9", "#FF4136", "#2ECC40", "#FF851B", "#7FDBFF", "#B10DC9", "#FFDC00", "#001f3f", "#39CCCC",
            "#01FF70", "#85144b", "#F012BE", "#3D9970", "#111111", "#AAAAAA", "#f38b4a", "#56d798", "#ff8397", "#6970d5", "#FF86BA",
            "#A3940D", "#058AA3", "#944E6D", "#BD6500"],
          borderWidth: 1,
            borderColor: '#ddd'
        }
      ]
      },

      options: {
        responsive: true,
        hover: {
          animationDuration: 0
        },
        animation: {
          onComplete: function() {
            this.chart.controller.draw();
            drawValue(this, 1);
          },
          onProgress: function(state) {
            var animation = state.animationObject;
            drawValue(this, animation.currentStep / animation.numSteps);
          }
        },
        legend:{
          display:false,
          position : 'bottom',
          labels: {
            boxWidth: 20,
            fontColor: '#111',
            padding: 15
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label (t, d) {
              const xLabel = d.datasets[t.datasetIndex].label;
              const yLabel = t.yLabel >= 1000 ? 'S/' + t.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 'S/' + t.yLabel;
              return xLabel + ': ' + yLabel;
            }
        }
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback: (label:number , index, labels) => {
                return 'S/' +  label.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') ;
              }
            }
          }
        ]
      },

        plugins: {
          datalabels: {
            color: 'green',
            anchor: "end",
            align: "end",
            textAlign: 'center',
            font: {
              weight: 'bold',
              lineHeight: 2.3,
              size: 10
            },
            formatter: function (value, context) {
              return self.porcentajeSectorSoles[context.dataIndex] + " %";
            }

          }
        },
      }
    });

      var insideFontColor = '214, 208, 207';
      var outsideFontColor = '13, 31, 111';
      var topThreshold = 50;

      var modifyCtx = function(ctx) {
        ctx.font = Chart.helpers.fontString(10, 'bold', Chart.defaults.global.defaultFontFamily);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'center';
        return ctx;
      };

      var fadeIn = function(ctx, obj, x, y, black, step) {
        var ctx = modifyCtx(ctx);
        var alpha = 0;
        ctx.fillStyle = black ? 'rgba(' + outsideFontColor + ',' + step + ')' : 'rgba(' + insideFontColor + ',' + step + ')';
        ctx.fillText(obj, x, y);
      };

      var drawValue = function(context, step) {
        var ctx = context.chart.ctx;

        context.data.datasets.forEach(function (dataset) {
          for (var i = 0; i < dataset.data.length; i++) {
            var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
            var textY = (model.y > topThreshold) ? model.y - 3 : model.y + 20;
            fadeIn(ctx, dataset.data[i], model.x, textY, model.y > topThreshold, step);
          }
        });
      };

    this.pieChartSectorSoles.update();
  }


  crearChartSectorDolares() {
    var self = this;
    this.pieChartSectorDolares = new Chart('pieChartSectorDolares', {
      type: 'bar',
      data: {
        labels: this.nombreSectorDolares,
        datasets: [{
          label: 'Total',
          data: this.montoSectorFondoDolares,
          backgroundColor: ["#001f3f", "#AAAAAA", "#f38b4a", "#56d798", "#ff8397", "#6970d5", "#FF86BA",
            "#A3940D", "#058AA3", "#944E6D", "#BD6500", "#0074D9", "#FF4136", "#2ECC40", "#FF851B", "#7FDBFF", "#B10DC9", "#FFDC00", "#001f3f", "#39CCCC", "#01FF70", "#F012BE", "#3D9970", "#111111"],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        hover: {
          animationDuration: 0
        },
        animation: {
          onComplete: function() {
            this.chart.controller.draw();
            drawValue(this, 1);
          },
          onProgress: function(state) {
            var animation = state.animationObject;
            drawValue(this, animation.currentStep / animation.numSteps);
          }
        },
        legend:{
          display:false,
          position : 'bottom',
          labels: {
            boxWidth: 20,
            fontColor: '#111',
            padding: 15
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label (t, d) {
              const xLabel = d.datasets[t.datasetIndex].label;
              const yLabel = t.yLabel >= 1000 ? '$' + t.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '$' + t.yLabel;
              return xLabel + ': ' + yLabel;
            }
        }
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback: (label:number , index, labels) => {
                return '$' +  label.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') ;
              }
            }
          }
        ]
      },
        plugins: {
          datalabels: {
            color: 'green',
            anchor: "end",
            align: "end",
            textAlign: 'center',
            font: {
              weight: 'bold',
              lineHeight: 2.3,
              size: 10
            },
            formatter: function (value, context) {
              return self.porcentajeSectorDolares[context.dataIndex] + " %";
            }

          }
        },
      }
    });

      var insideFontColor = '214, 208, 207';
      var outsideFontColor = '13, 31, 111';
      var topThreshold = 50;

      var modifyCtx = function(ctx) {
        ctx.font = Chart.helpers.fontString(10, 'bold', Chart.defaults.global.defaultFontFamily);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'center';
        return ctx;
      };

      var fadeIn = function(ctx, obj, x, y, black, step) {
        var ctx = modifyCtx(ctx);
        var alpha = 0;
        ctx.fillStyle = black ? 'rgba(' + outsideFontColor + ',' + step + ')' : 'rgba(' + insideFontColor + ',' + step + ')';
        ctx.fillText(obj, x, y);
      };

      var drawValue = function(context, step) {
        var ctx = context.chart.ctx;

        context.data.datasets.forEach(function (dataset) {
          for (var i = 0; i < dataset.data.length; i++) {
            var model = dataset._meta[Object.keys(dataset._meta)[0]].data[i]._model;
            var textY = (model.y > topThreshold) ? model.y - 3 : model.y + 20;
            fadeIn(ctx, dataset.data[i], model.x, textY, model.y > topThreshold, step);
          }
        });
      };
    this.pieChartSectorDolares.update();
  }


  calcularTotalFondo() {
    this.montoTotalS = 0;
    this.montoDisponibleS = 0;
    this.montoEjecutadoS = 0;
    this.montoTotalD = 0;
    this.montoDisponibleD = 0;
    this.montoEjecutadoD = 0;
    for (let item of this.fondo) {
      if (item.Moneda == this.Label_id_soles) {
        this.montoTotalS = Math.round((Number(item.Monto_Fondo) + Number(this.montoTotalS)) * 100) / 100;
        this.montoDisponibleS = Math.round((Number(item.Monto_Fondo_Disponible) + Number(this.montoDisponibleS)) * 100) / 100;
        this.montoEjecutadoS = Math.round((Number(item.Monto_Fondo_Ejecutado) + Number(this.montoEjecutadoS)) * 100) / 100;
      } else if (item.Moneda == this.Label_id_dolares) {
        this.montoTotalD = Math.round((Number(item.Monto_Fondo) + Number(this.montoTotalD)) * 100) / 100;
        this.montoDisponibleD = Math.round((Number(item.Monto_Fondo_Disponible) + Number(this.montoDisponibleD)) * 100) / 100;
        this.montoEjecutadoD = Math.round((Number(item.Monto_Fondo_Ejecutado) + Number(this.montoEjecutadoD)) * 100) / 100;
      }
    }
  }

  /*Fondo en Moneda*/

  getTotalSolesDisponible() {
    return this.fondoSoles.map(t => t.Monto_Fondo_Disponible).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalSolesEjecutado() {
    return this.fondoSoles.map(t => t.Monto_Fondo_Ejecutado).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalDolaresDisponible() {
    return this.fondoDolares.map(t => t.Monto_Fondo_Disponible).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalDolaresEjecutado() {
    return this.fondoDolares.map(t => t.Monto_Fondo_Ejecutado).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  /*Detalle Fondo - sector*/
  getTotalSectorTotal() {
    return this.sectores.map(t => t.Monto_Sector_Fondo).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalSectorBloqueado() {
    return this.sectores.map(t => t.Monto_Sector_Fondo_Bloqueado).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalSectorDisponible() {
    return this.sectores.map(t => t.Monto_Sector_Fondo_Disponible).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalSectorEjecutado() {
    return this.sectores.map(t => t.Monto_Sector_Fondo_Ejecutado).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  /*Concentración Adquirente*/
  getTotalSolesAdquirente() {
    return this.listadoCAdquirentesSoles.map(t => t.montoFondo).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  getTotalDolaresAdquirente() {
    return this.listadoCAdquirentesDolares.map(t => t.montoFondo).reduce((acc, value) => Number(acc) + Number(value), 0);
  }
  /*detalle Adquirente*/
  getTotalVnppDetalleAdquirente() {
    return this.detalleAdquirente.map(t => t.VNPP).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  /*popUpSector*/
  Sector(row: any, moneda) {
    this.fondonombre = row.Nombre_Fondo
    this.moneda = moneda;
    this.sectores = row.sectores_fondo
    this.dataSourceDetalleFondo = new MatTableDataSource(this.sectores);
    this.dataSourceDetalleFondo.sort = this.sortDetalleFondo;
    this.dataSourceDetalleFondo.paginator = this.paginatorDetalleFondo;
    this.popup = true;
  }
  /*popUpAdquirente*/
  verDetalleAdquirente(row: any) {
    this.loading = true;
    this.riesgoService.VerConcentracionAdquirente(row).subscribe(
      res => {
        this.loading = false;
        this.detalleAdquirente = res;
        this.nombreAdquirente = this.detalleAdquirente[0].Razon_Social;
        this.dataSourceAdquirenteDetalle = new MatTableDataSource(this.detalleAdquirente);
        this.dataSourceAdquirenteDetalle.sort = this.sortDetalleAdquirente;
        this.dataSourceAdquirenteDetalle.paginator = this.paginatorDetalleAdquirente;
      },
      () => {
        this.loading = false;
        Swal.fire({
          title: 'Error',
          text: "Detalle no encontrado. Contactar con soporte.",
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    )
    this.popupAdquirente = true;
  }

  cerrarPopup() {
    this.sectores = [];
    this.popup = false;
  }
  cerrarPopupAdquirente() {
    this.detalleAdquirente = [];
    this.popupAdquirente = false;
  }


}
